import http from './http'

// export const findAll = ({ isMobile = 1, basicBanner = 1, customSort = 1 } = {}) => {
//   return http.post('cms/basic/mobile/findAll', {
//     isMobile, basicBanner, customSort
//   })
// }


export const findAll = ( { categoryAppid, categoryType } = {}) => {
  //console.log(categoryType, categoryAppid)
  return http.post('/cms/category/mobile/findAll', {
    categoryAppid, categoryType
  })
}

export const findPage = ( { basicCategoryid, basicType, page = 1, size = 5 } = {}) => {
  return http.post('/cms/basic/mobile/findPage?page={page}&size={size}', {
    basicCategoryid, basicType
  }, {
    params: {
      page, size
    }
  })
}


export const findSonTrees = ( { basicCategoryid, categoryAppid} = {}) => {
  return http.post('/cms/category/mobile/findSonTrees/{basicCategoryid}?categoryAppid={categoryAppid}', {
  }, {
    params: {
      basicCategoryid, categoryAppid
    }
  })
}

export const getArticle = (articleId) => {
  return http.post('/cms/article/mobile/get?articleId={articleId}', null, {
    params: {
      articleId
    }
  })
}

export const fullTextSearch = ({index='app',type='article',key,start=0,row=20,categoryId,heightFields=['basicTitle', 'basicDescription', 'articleContent'] }={}) => {
  return http.post('/cms/basic/mobile/fullTextSearch', {index, type, key, start, categoryId, row, heightFields})
}



